// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-R":"R_dpu-detail-R__Ko_Nf"};